import React from "react";
import { Link, useParams } from "react-router-dom";

export const StateSchemes = ({
  schemes,
  voterid,
  voterdata,
}: {
  schemes: any[];
  voterid: number | null;
  voterdata: any;
}) => {
  const { projectid } = useParams();

  if (!schemes.length) {
    return (
      <div className="text-center text-sm text-gray-600 dark:text-gray-300 my-4">
        No schemes available.
      </div>
    );
  }

  return (
    <>
      {schemes.map((item: any) => {
        const { id, summary, eligibility } = item;
        const {
          schemeName,
          tags = [],
          nodalMinistryName,
          briefDescription,
        } = summary;

        // console.log("Scheme ID:", id, "Eligibility:", eligibility);

        // Set badge appearance based on eligibility
        let badgeColor = "bg-gray-500 text-white";
        let badgeText = "Not Checked";
        if (eligibility === true) {
          badgeColor = "bg-green-600 text-white";
          badgeText = "Eligible";
        } else if (eligibility === false) {
          badgeColor = "bg-orange-700 text-white";
          badgeText = "Ineligible";
        }

        return (
          <Link
            key={id}
            to={`/project/${projectid}/schemess/schemeDetails/${id}`}
          >
            <div className="relative mx-auto rounded-xl shadow-md overflow-hidden w-full group hover:shadow-lg bg-white dark:bg-dark dark:shadow-xl dark:hover:shadow-2xl mb-4">
              <div
                className={`absolute top-2 left-2 px-3 py-2 rounded text-xs font-semibold  ${badgeColor}`}
              >
                {badgeText}
              </div>

              <div className="p-4 lg:p-8 w-full mt-4">
                <div className="flex flex-row items-center justify-between">
                  <div className="flex flex-col">
                    <h2>
                      <a className="block text-lg lg:text-[22px] leading-tight font-medium group-hover:text-darkIndigo-900 text-[#24262B] dark:text-white dark:group-hover:text-white">
                        {schemeName}
                      </a>
                    </h2>
                    {nodalMinistryName && (
                      <h2 className="mt-3 font-normal text-sm lg:text-base text-raven cursor-pointer hover:underline dark:text-indigo-100">
                        {nodalMinistryName}
                      </h2>
                    )}
                    <span className="mt-3 text-[#24262B] line-clamp-2 dark:text-indigo-100 text-xs lg:text-sm">
                      {briefDescription}
                    </span>
                  </div>
                </div>

                {tags.length > 0 && (
                  <div className="grid grid-cols-1 md:flex flex-wrap gap-4 justify-between items-center mt-3 w-full">
                    <div className="lg:w-[90%]">
                      <div className="flex items-center gap-1 flex-wrap">
                        {tags.map((tag: string) => (
                          <div
                            key={tag}
                            title={tag}
                            className="bg-transparent border border-solid hover:border-transparent border-green-700 text-green-700 hover:bg-green-700 dark:border-green-500 dark:text-green-500 dark:hover:bg-green-500 hover:text-white dark:hover:text-white rounded py-1.5 px-2.5 text-xs inline-block font-medium leading-none text-left md:text-center hover:shadow-md mr-2 mt-1 !rounded-full cursor-pointer"
                          >
                            <span>{tag}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Link>
        );
      })}
    </>
  );
};
